var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#454545",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(1.0039 0 0 1.0039 -3.75e-7 -.11714)",
    points: "23.906 11.745 23.906 7.6754 0 7.6754 0 11.745"
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(1.0039 0 0 1.0039 -3.75e-7 -.11714)",
    points: "21.25 13.045 2.6562 13.045 4.486 22.14 19.393 22.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(1.0039 0 0 1.0039 -3.75e-7 -.11714)",
    points: "4.5 11 3 10 9.5 2 11 3"
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(-1.0039 0 0 1.0039 34.133 -.11714)",
    points: "14.5 11 13 10 19.5 2 21 3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.3c365a6fa9b9e0b8e982b7efb20a944e.svg";
export { ForwardRef as ReactComponent };